<body>
    <div class="container0">
      <div id="email-verification">
        <h3>Nous avons envoyé un lien de vérification à votre adresse email.</h3>
        
        <div class="container">
            <div class="step row">
                <span class="step-number">1</span>
                <h5>Cliquez sur le lien que nous avons envoyé à votre adresse email pour valider votre adresse</h5>
              </div>
        </div>
        
        <div class="container">
            <div class="step row">
                <span class="step-number">2</span>
                <h5>Une fois votre adresse email validée, cliquez sur le bouton <button onclick="reloadPage()">Continuer</button></h5>
              </div>
        </div>
    
        <h6>Si vous n'avez pas reçu de lien, cliquez ici 
          <button class="resend-button" onclick="onResendClick()">Réenvoyer l'email de vérification</button>
        </h6>
      </div>
    </div>
    
  
    </body>